import React, { FC, ReactNode } from 'react';
import cx from 'classnames';
import Badge from './Badge';
import UserIcon from './UserIcon';
import MenuIcons, { MenuIcon } from './MenuIcons';
import styles from './Icon.css';

type Props = {
  badge?: boolean;
  className?: string;
  icon: string | MenuIcon | ReactNode;
  isBranded?: boolean;
};

const Icon: FC<Props> = ({
  badge,
  className,
  icon,
  isBranded
}): JSX.Element | null => {
  if (icon === 'User') {
    return (
      <UserIcon badge={badge} className={className} isBranded={isBranded} />
    );
  }

  if (MenuIcons[icon as MenuIcon] === undefined) {
    return <span className={cx(styles.component, className)}>{icon}</span>;
  }

  const IconComponent = MenuIcons[icon as MenuIcon];

  return (
    <div className={cx(styles.component, className)}>
      <IconComponent />
      {badge && <Badge className={styles.badge} />}
    </div>
  );
};

export default Icon;
